import React from "react";
import { Modal, ModalBody } from "@vds/modals";
import { Title } from "@vds/typography";
import { Icon } from "@vds/icons";
import { FlexRow } from "../../components/core/utility";
import { Button } from "@vds/buttons";
import { css } from "@emotion/react";

const StyledModal = css`
  // max-height: 99vmin;
  padding: 1rem 1rem 1rem 1rem;
  border-radius: 0.5rem;
  width: 20rem !important;
  min-height: 100px !important;
  @media (max-width: 767px) {
    // width: auto% !important;
    // height: auto;
    min-height: 100px !important;
    padding: 1rem 1rem 1rem 1rem;
    padding-right: 2px;
  }
  .ModalDialogWrapper-sc-ov12ij-0 > span.hULveg {
    padding-right: 0px;
  }

  .ModalDialogWrapper-sc-ov12ij-0 {
    min-height: 100px !important;
  }

  & footer {
    padding: 0;
  }
`;

const InfoModal = ({ isOpen, onClose, handleConfirmOk, assetType }) => {
  return (
    <Modal
      role="dialog"
      ariaLabel="Configure MMIDs"
      hideCloseButton={false}
      opened={isOpen}
      disableOutsideClick
      css={StyledModal}
      closeButton={
        <FlexRow justifyContent="space-between" style={{ marginLeft: "1.3rem", marginTop: "1rem" }} onClick={(event) => event.preventDefault()}>
          <Title>Message</Title>
          <div onClick={onClose} style={{ marginRight: "1rem" }}>
            <Icon
              aria-label="close"
              alt="close-icon"
              role="img"
              name="close"
              size="medium"
              color="#000000"
              style={{ cursor: "pointer", outline: "none" }}
            />
          </div>
        </FlexRow>
      }
    >
      {assetType === "Vehicle" ? <ModalBody>No more Vehicle can be added.</ModalBody> : <ModalBody>No more Asset can be added.</ModalBody>}
      <FlexRow justifyContent="flex-end">
        <Button size="small" onClick={handleConfirmOk}>
          Ok
        </Button>
      </FlexRow>
    </Modal>
  );
};
export default InfoModal;
